'use client';

import { useState } from 'react';
import Image from 'next/image';
import { modelIcon } from '@/lib/studio/model-brand';

/** Locally served brand SVGs; provider API currently has no icon metadata. */
export function BrandIcon({ modelId, fallbackLetter, size = 32, rounded = 'lg' }: {
  modelId?: string | null; fallbackLetter?: string; size?: number; rounded?: 'md' | 'lg' | 'full';
}) {
  const icon = modelIcon(modelId);
  const initial = typeof modelId === 'string' ? modelId[0]?.toUpperCase() : undefined;
  const [failedIcon, setFailedIcon] = useState<string>();
  return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center overflow-hidden bg-white text-violet-700 ${
    rounded === 'full' ? 'rounded-full' : rounded === 'md' ? 'rounded-md' : 'rounded-lg'
  }`} style={{ width: size, height: size }}>
    {icon && failedIcon !== icon ? <Image src={`/model-icons/${icon}.svg`} alt=""
      width={Math.round(size * 0.75)} height={Math.round(size * 0.75)} unoptimized
      onError={() => setFailedIcon(icon)} /> :
      <span style={{ fontSize: size * 0.5 }} className="font-bold">{fallbackLetter ?? initial ?? 'AI'}</span>}
  </span>;
}
